import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatLabel } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatModule } from '../appModules/mat.module';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { ExportService } from '../shared/services/exportservice';

@Component({
  selector: 'app-results-list',
  imports: [
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    CommonModule,
    MatLabel,
    MatSelectModule,
    FormsModule,
    MatPaginatorModule,
    MatModule,
    ReactiveFormsModule
  ],
  templateUrl: './results-list.component.html',
  styleUrl: './results-list.component.scss'
})
export class ResultsListComponent {
  results:any
  courseList:any;
  semesterList:any
  selectedSemesterId: string = '';
  selectedCourseId: string = '';
  selectedSemesterNumber:string = '';
  searchText: string = '';
  pagination = {
    length: 0,
    page: 1,
    limit: 10,
  };
  currentPage=0;
  displayedColumns: string[] = [
    'sno','name','surname','register_no','crs_code','semester_number','scheme_type','exam_month','result_type','ia_sub1','see_sub1','total_sub1','result_sub1',
    'ia_sub2','see_sub2','total_sub2','result_sub2','ia_sub3','see_sub3','total_sub3','result_sub3',
    'ia_sub4','see_sub4','total_sub4','result_sub4','ia_sub5','see_sub5','total_sub5','result_sub5',
    'ia_sub6','see_sub6','total_sub6','result_sub6','ia_sub7','see_sub7','total_sub7','result_sub7',
    'ia_sub8','see_sub8','total_sub8','result_sub8',
  ]

  constructor(private http: HttpClient, private api: ApiService, private common: CommonService, private exportService: ExportService) { }

  ngOnInit(){
    this.get_all_results();
    this.getCourseList();
    this.getSemesterList();
  }

  get_all_results_download(courseId?: string, semesterId?: string, search?: string) {
    const userData = localStorage.getItem('user');
  
    if (!userData) {
      console.error('No user data found in localStorage');
      return;
    }
  
    const user = JSON.parse(userData);
    interface ResultFilterPayload {
      user_id: string;
      course_id?: string;
      semesterNumber?: string;
      search?: String;
    }
    
    const payload: ResultFilterPayload = {
      user_id: user.userId
    };
    
    if (courseId) {
      payload.course_id = courseId
    }
    if (semesterId) {
      payload.semesterNumber = semesterId;
    }
    if (search){
      payload.search = search
    }
  
    this.api.post(`results/list_all_results`, payload, true).subscribe({
      next: (resp: any) => {
        if (resp.status) {
          console.log('students/Students fetched successfully:', resp.data);
          // You can bind resp.data to a variable for displaying in a table
          this.results= resp.data;
          this.pagination.length = resp?.totalCount || 0;
          const req = {
            displayedColumns: this.displayedColumns,
            data: this.results,
            filename: 'result_list',
            dateField: ['dob'] // or any date fields if needed
          };
          
          this.exportService.exportExcel(req);
        } else {
          console.error('Failed to fetch results:', resp.message);
        }
      },
      error: (error) => {
        console.error('API error:', error);
      }
    });
  }

  get_all_results(courseId?: string, semesterId?: string, search?: string) {
    const userData = localStorage.getItem('user');

    const queryParam: any = [];
    queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);
  
    if (!userData) {
      console.error('No user data found in localStorage');
      return;
    }
  
    const user = JSON.parse(userData);
    interface ResultFilterPayload {
      user_id: string;
      course_id?: string;
      semesterNumber?: string;
      search?: String;
    }
    
    const payload: ResultFilterPayload = {
      user_id: user.userId
    };
    
    if (courseId) {
      payload.course_id = courseId
    }
    if (semesterId) {
      payload.semesterNumber = semesterId;
    }
    if (search){
      payload.search = search
    }
  
    this.api.post(`results/list_all_results?${queryParam.join('&')}`, payload, true).subscribe({
      next: (resp: any) => {
        if (resp.status) {
          console.log('students/Students fetched successfully:', resp.data);
          // You can bind resp.data to a variable for displaying in a table
          this.results= resp.data;
          this.pagination.length = resp?.totalCount || 0;
        } else {
          console.error('Failed to fetch results:', resp.message);
        }
      },
      error: (error) => {
        console.error('API error:', error);
      }
    });
  }

  getCourseList() {
    this.api.get(`courses/list`).subscribe(resp => {
      if (resp && resp.success) {
        this.courseList = resp.data;
        // this.courseId = resp.data.id
      } else {
        console.error('Failed to load courses:', resp);
        this.courseList = [];
      }
    });
  }

  getSemesterList() {
    this.api.get(`semesters/list`).subscribe(resp => {
      if (resp && resp.success) {
        this.semesterList = resp.data;
        // this.semisterId = resp.data.id
      } else {
        console.error('Failed to load semesters:', resp);
        this.semesterList = [];
      }
    });
  }

  onFiltersChange() {
    console.log('Course:', this.selectedCourseId, 'Semester:', this.selectedSemesterNumber);
    if (this.selectedCourseId && this.selectedSemesterNumber) {
      this.get_all_results(this.selectedCourseId, this.selectedSemesterNumber);
    }
  }
  applyFilter() {
    this.pagination.page = 1;
    this.get_all_results(this.selectedCourseId, this.selectedSemesterNumber, this.searchText);
  }

  pageEvent(e: any) {
    this.pagination.page = e.pageIndex + 1;
    this.pagination.limit = e.pageSize;
    this.currentPage = e.pageIndex * e.pageSize;
    this.get_all_results(this.selectedCourseId, this.selectedSemesterNumber);
  }
}
